import styled from "styled-components";
import colors from "../../../../../css/colors";

interface DropdownSelectWrapperProps {
  disabled?: boolean;
}

export const DropdownSelectWrapper = styled.div<DropdownSelectWrapperProps>`
  display: flex;
  flex: 1;
  flex-direction: column;

  .ant-select {
    height: 35px;
  }

  .ant-select-selector {
    height: 100% !important;
    border-radius: 6px !important;
  }

  .ant-select-disabled.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) => (props.disabled ? colors.GREY_BACKGROUND : colors.WHITE)};
  }

  .ant-select-selection-item {
    font-size: 16px !important;
    color: ${colors.CHARCOAL} !important;
  }
`;
